/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import NotificationSystem from 'rc-notification';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { setRUTFormat } from '../../shared/utils';

const CallComponent = (props) => {
  console.log("PropsMessage: ", props.message);
  const {
    phone_number: phoneNumber,
    rut,
    // agent,
    // timestamp,
    names,
    paternalSurname,
    maternalSurname,
    products,
    isClient,
  } = props.message;
  const fullName = `${names} ${paternalSurname} ${maternalSurname}`;
  const onClick = _rut => () => {
    props.history.push(`/casos/new/${_rut}`);
    props.onClose();
  };
  const RUT = rut ? setRUTFormat(rut) : undefined;
  return (
    <Fragment>
      <div className="call-rectangle">
        <div>
          <p className="incoming-call-text">Llamada entrante <span className="call-number">{phoneNumber || 'Indefinido'}</span></p>
          <h6 className="caller-name">
            <strong>{isClient ? fullName : 'Número no registrado'}</strong>
          </h6>
          <h6 className="caller-rut">{isClient ? RUT : RUT || 'Sin RUT asociado'}</h6>
          {!props.message.quotationId && <><h6 className="call-products-text">
            <strong>
              Productos
            </strong>
          </h6>
            <h6 className="caller-plan-name">
              {
                isClient && !isEmpty(products)
                  ? map(products, product => `${product.productName} #${product.id}`)
                  : 'Sin productos asociados'
              }
            </h6></>}
          <br />
          <div className="inlineaner">
            {
              isClient && !props.message.quotationId &&
              <button
                className="asignar btn btn-secondary"
                style={{ color: '#000000', fontSize: '12px', padding: '1px 8px' }}
                type="button"
                onClick={onClick(rut)}
              >
                + Nuevo Caso
              </button>
            }
            <button
              className="asignar btn btn-secondary"
              style={{ color: '#000000', fontSize: '12px', padding: '1px 8px' }}
              type="button"
              onClick={props.onClose}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
      <div className="greenBottomBorder" />
    </Fragment>
  );
};

const showNotification = ({ message, history }) => {
  const key = Date.now();
  NotificationSystem.newInstance({}, (notification) => {
    notification.notice({
      content: <CallComponent onClose={() => notification.removeNotice(key)} message={message} history={history} />,
      duration: null,
      style: {
        top: 0, left: 'calc(98vw - 100%)', position: 'relative', zIndex: '999999999',
      },
      key,
      className: 'right-up',
    });
  });
};

export default showNotification;
